// import React, { useEffect, useMemo, useState, useCallback, useContext } from 'react';
// import axios from 'axios';
// import { API_URL } from '../../Constants';
// import { AuthContext } from "../context/AuthContext";
// import {
//   Plus, X, Pencil, Trash2, Search, Check, AlertCircle,
//   Type, AlignLeft, Hash, Calendar, ToggleLeft, ListChecks,
//   Mail, Phone, Loader2, Lock, CheckCircle2,
// } from 'lucide-react';

// /* ────────────────────────────────────────────────────────────────
//    Field type registry
//    ──────────────────────────────────────────────────────────────── */
// const FIELD_TYPES = [
//   { value: 'TEXT', label: 'Text', icon: Type, hint: 'One line of text' },
//   { value: 'TEXTAREA', label: 'Paragraph', icon: AlignLeft, hint: 'A few lines of text' },
//   { value: 'NUMBER', label: 'Number', icon: Hash, hint: 'Digits only' },
//   { value: 'DATE', label: 'Date', icon: Calendar, hint: 'A calendar date' },
//   { value: 'BOOLEAN', label: 'Yes / No', icon: ToggleLeft, hint: 'A simple switch' },
//   { value: 'DROPDOWN', label: 'Dropdown', icon: ListChecks, hint: 'Pick one option' },
//   { value: 'EMAIL', label: 'Email', icon: Mail, hint: 'An email address' },
//   { value: 'PHONE', label: 'Phone', icon: Phone, hint: 'A phone number' },
// ];
// const TYPE_MAP = Object.fromEntries(FIELD_TYPES.map((t) => [t.value, t]));

// /* ────────────────────────────────────────────────────────────────
//    Live preview
//    ──────────────────────────────────────────────────────────────── */
// function FieldPreview({ label, fieldType, options, required }) {
//   const cleanOptions = (options || []).filter((o) => o.trim());
//   const displayLabel = label.trim() || 'Untitled field';

//   return (
//     <div className="lfc-preview">
//       <label className="lfc-preview-label">
//         {displayLabel}
//         {required && <span className="lfc-req">*</span>}
//       </label>
//       {fieldType === 'TEXTAREA' && <textarea disabled rows={3} placeholder="Team types their answer here…" />}
//       {fieldType === 'BOOLEAN' && (
//         <div className="lfc-preview-switch">
//           <div className="lfc-switch-track"><div className="lfc-switch-thumb" /></div>
//           <span>No</span>
//         </div>
//       )}
//       {fieldType === 'DROPDOWN' && (
//         <select disabled>
//           <option>{cleanOptions[0] || 'Choose an option…'}</option>
//           {cleanOptions.slice(1).map((o, i) => <option key={i}>{o}</option>)}
//         </select>
//       )}
//       {fieldType === 'DATE' && <input disabled type="text" placeholder="dd / mm / yyyy" />}
//       {fieldType === 'NUMBER' && <input disabled type="text" placeholder="0" />}
//       {fieldType === 'EMAIL' && <input disabled type="text" placeholder="name@company.com" />}
//       {fieldType === 'PHONE' && <input disabled type="text" placeholder="+91 98765 43210" />}
//       {fieldType === 'TEXT' && <input disabled type="text" placeholder="Team types their answer here…" />}
//     </div>
//   );
// }

// /* ────────────────────────────────────────────────────────────────
//    Main page
//    ──────────────────────────────────────────────────────────────── */
// export default function LeadConfig() {
//   const { user } = useContext(AuthContext);
//   const isCompanyOwner = user?.accountType === "COMPANY";
//   const companyId = isCompanyOwner ? user?.id : user?.companyId;
//   const token = localStorage.getItem('token');

//   const [fields, setFields] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeOnly, setActiveOnly] = useState(false);
//   const [query, setQuery] = useState('');

//   const [panelMode, setPanelMode] = useState(null); // 'create' | 'edit' | null
//   const [editingId, setEditingId] = useState(null);
//   const [form, setForm] = useState({ label: '', fieldType: 'TEXT', options: [''], required: false });
//   const [formError, setFormError] = useState('');
//   const [saving, setSaving] = useState(false);

//   const [confirmDelete, setConfirmDelete] = useState(null);
//   const [deletingId, setDeletingId] = useState(null);
//   const [togglingId, setTogglingId] = useState(null);
//   const [toastMessage, setToastMessage] = useState(null); // Renamed to avoid react-toastify conflict naming

//   // Setup Axios Instance
//   const axiosInstance = useMemo(() => axios.create({
//     baseURL: API_URL,
//     headers: { Authorization: `Bearer ${token}` }
//   }), [token]);

//   const API_BASE = '/api/lead-fields';

//   // Component-bound API logic
//   const api = useMemo(() => ({
//     list: async (activeOnly) => {
//       const { data } = await axiosInstance.get(`${API_BASE}/company/${companyId}?activeOnly=${activeOnly ? 'true' : 'false'}`);
//       return data;
//     },
//     create: async (payload) => {
//       const body = {
//         companyId: companyId,
//         label: payload.label.trim(),
//         fieldType: payload.fieldType,
//         required: !!payload.required,
//       };
//       if (payload.fieldType === 'DROPDOWN') {
//         body.options = payload.options.filter((o) => o.trim());
//       }
//       const { data } = await axiosInstance.post(API_BASE, body);
//       return data;
//     },
//     update: async (id, payload) => {
//       const body = {
//         label: payload.label.trim(),
//         fieldType: payload.fieldType,
//         required: !!payload.required,
//       };
//       if (payload.fieldType === 'DROPDOWN') {
//         body.options = payload.options.filter((o) => o.trim());
//       }
//       const { data } = await axiosInstance.put(`${API_BASE}/${id}?companyId=${companyId}`, body);
//       return data;
//     },
//     setActive: async (id, active) => {
//       const { data } = await axiosInstance.put(`${API_BASE}/${id}/active?companyId=${companyId}&active=${active ? 'true' : 'false'}`);
//       return data;
//     },
//     remove: async (id) => {
//       const { data } = await axiosInstance.delete(`${API_BASE}/${id}?companyId=${companyId}`);
//       return data;
//     }
//   }), [axiosInstance, companyId]);

//   const loadFields = useCallback(async () => {
//     if (!companyId) return; // Prevent loading without auth context
//     setLoading(true);
//     try {
//       const data = await api.list(activeOnly);
//       setFields(data || []);
//     } catch (e) {
//       showToast(e.response?.data?.message || e.message || 'Could not load fields', 'error');
//     } finally {
//       setLoading(false);
//     }
//   }, [activeOnly, api, companyId]);

//   useEffect(() => { loadFields(); }, [loadFields]);

//   useEffect(() => {
//     if (!toastMessage) return;
//     const t = setTimeout(() => setToastMessage(null), 3200);
//     return () => clearTimeout(t);
//   }, [toastMessage]);

//   function showToast(message, kind = 'success') {
//     setToastMessage({ message, kind });
//   }

//   const filtered = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     if (!q) return fields;
//     return fields.filter((f) => f.label.toLowerCase().includes(q) || f.fieldKey?.toLowerCase().includes(q));
//   }, [fields, query]);

//   const previewKey = useMemo(() => {
//     if (panelMode === 'edit') return null;
//     let base = form.label.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
//     return base || 'field';
//   }, [form.label, panelMode]);

//   function openCreate() {
//     setForm({ label: '', fieldType: 'TEXT', options: [''], required: false });
//     setFormError('');
//     setEditingId(null);
//     setPanelMode('create');
//   }

//   function openEdit(field) {
//     setForm({
//       label: field.label,
//       fieldType: field.fieldType,
//       options: field.options && field.options.length ? field.options : [''],
//       required: field.required,
//     });
//     setFormError('');
//     setEditingId(field.id);
//     setPanelMode('edit');
//   }

//   function closePanel() {
//     setPanelMode(null);
//     setEditingId(null);
//     setFormError('');
//   }

//   function setOption(i, value) {
//     setForm((f) => ({ ...f, options: f.options.map((o, idx) => (idx === i ? value : o)) }));
//   }
//   function addOption() {
//     setForm((f) => ({ ...f, options: [...f.options, ''] }));
//   }
//   function removeOption(i) {
//     setForm((f) => ({ ...f, options: f.options.filter((_, idx) => idx !== i) }));
//   }

//   async function handleSubmit(e) {
//     e.preventDefault();
//     setFormError('');
//     if (!form.label.trim()) { setFormError('Give this field a label.'); return; }
//     if (form.fieldType === 'DROPDOWN' && form.options.filter((o) => o.trim()).length === 0) {
//       setFormError('Add at least one option for a dropdown field.');
//       return;
//     }
//     setSaving(true);
//     try {
//       if (panelMode === 'create') {
//         const created = await api.create(form);
//         setFields((prev) => [...prev, created]);
//         showToast(`"${created.label}" added to the lead form`);
//       } else {
//         const updated = await api.update(editingId, form);
//         setFields((prev) => prev.map((f) => (f.id === editingId ? updated : f)));
//         showToast(`"${updated.label}" updated`);
//       }
//       closePanel();
//     } catch (err) {
//       setFormError(err.response?.data?.message || err.message || 'Something went wrong. Try again.');
//     } finally {
//       setSaving(false);
//     }
//   }

//   async function handleToggleActive(field) {
//     setTogglingId(field.id);
//     const next = !field.active;
//     setFields((prev) => prev.map((f) => (f.id === field.id ? { ...f, active: next } : f)));
//     try {
//       await api.setActive(field.id, next);
//     } catch (err) {
//       setFields((prev) => prev.map((f) => (f.id === field.id ? { ...f, active: field.active } : f)));
//       showToast(err.response?.data?.message || err.message || 'Could not update this field', 'error');
//     } finally {
//       setTogglingId(null);
//     }
//   }

//   async function handleDelete(field) {
//     setDeletingId(field.id);
//     try {
//       await api.remove(field.id);
//       setFields((prev) => prev.filter((f) => f.id !== field.id));
//       showToast(`"${field.label}" deleted`);
//     } catch (err) {
//       showToast(err.response?.data?.message || err.message || 'Could not delete this field', 'error');
//     } finally {
//       setDeletingId(null);
//       setConfirmDelete(null);
//     }
//   }

//   return (
//     <div className="lfc-root">
//       <style>{CSS}</style>

//       <div className="lfc-page">
//         <header className="lfc-topbar">
//           <div>
//             <span className="lfc-eyebrow">Lead configuration</span>
//             <h1>Custom lead fields</h1>
//             <p className="lfc-sub">Add the questions your team should answer on every lead. They appear on the lead form the moment you save them.</p>
//           </div>
//           <button className="lfc-btn-primary" onClick={openCreate}>
//             <Plus size={17} /> Add field
//           </button>
//         </header>

//         <div className="lfc-toolbar">
//           <div className="lfc-search">
//             <Search size={16} />
//             <input
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               placeholder="Search fields…"
//             />
//           </div>
//           <div className="lfc-segmented">
//             <button className={!activeOnly ? 'is-active' : ''} onClick={() => setActiveOnly(false)}>All</button>
//             <button className={activeOnly ? 'is-active' : ''} onClick={() => setActiveOnly(true)}>Active only</button>
//           </div>
//           <span className="lfc-count">{loading ? '…' : `${filtered.length} field${filtered.length === 1 ? '' : 's'}`}</span>
//         </div>

//         <div className="lfc-panel-surface">
//           {loading ? (
//             <div className="lfc-skeletons">
//               {[0, 1, 2].map((i) => <div key={i} className="lfc-skeleton-row" />)}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="lfc-empty">
//               <div className="lfc-empty-badge"><ListChecks size={22} /></div>
//               <h3>{query ? 'No fields match your search' : 'No custom fields yet'}</h3>
//               <p>{query ? 'Try a different name or clear the search.' : 'Create your first field so your team can capture more on every lead.'}</p>
//               {!query && (
//                 <button className="lfc-btn-primary" onClick={openCreate}><Plus size={17} /> Add field</button>
//               )}
//             </div>
//           ) : (
//             <table className="lfc-table">
//               <thead>
//                 <tr>
//                   <th>Field</th>
//                   <th>Type</th>
//                   <th>Required</th>
//                   <th>Status</th>
//                   <th aria-hidden="true" />
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((field) => {
//                   const type = TYPE_MAP[field.fieldType] || TYPE_MAP.TEXT;
//                   const Icon = type.icon;
//                   return (
//                     <tr key={field.id} className={!field.active ? 'is-inactive' : ''}>
//                       <td>
//                         <div className="lfc-field-cell">
//                           <span className="lfc-field-label">{field.label}</span>
//                           <span className="lfc-field-key">{field.fieldKey}</span>
//                         </div>
//                       </td>
//                       <td>
//                         <span className="lfc-type-badge">
//                           <Icon size={14} /> {type.label}
//                         </span>
//                       </td>
//                       <td>
//                         {field.required ? (
//                           <span className="lfc-required-yes"><Check size={15} /></span>
//                         ) : (
//                           <span className="lfc-required-no">—</span>
//                         )}
//                       </td>
//                       <td>
//                         <button
//                           className={`lfc-status-pill ${field.active ? 'is-on' : 'is-off'}`}
//                           onClick={() => handleToggleActive(field)}
//                           disabled={togglingId === field.id}
//                         >
//                           {togglingId === field.id ? <Loader2 size={13} className="lfc-spin" /> : <span className="lfc-status-dot" />}
//                           {field.active ? 'Active' : 'Inactive'}
//                         </button>
//                       </td>
//                       <td>
//                         <div className="lfc-row-actions">
//                           <button className="lfc-icon-btn" onClick={() => openEdit(field)} aria-label={`Edit ${field.label}`}>
//                             <Pencil size={15} />
//                           </button>
//                           <button className="lfc-icon-btn lfc-icon-btn-danger" onClick={() => setConfirmDelete(field)} aria-label={`Delete ${field.label}`}>
//                             <Trash2 size={15} />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>

//       {/* ── Create / edit drawer ───────────────────────────────── */}
//       {panelMode && (
//         <div className="lfc-overlay" onClick={closePanel}>
//           <aside className="lfc-drawer" onClick={(e) => e.stopPropagation()}>
//             <div className="lfc-drawer-head">
//               <h2>{panelMode === 'create' ? 'Add field' : 'Edit field'}</h2>
//               <button className="lfc-icon-btn" onClick={closePanel} aria-label="Close"><X size={18} /></button>
//             </div>

//             <form className="lfc-form" onSubmit={handleSubmit}>
//               <div className="lfc-form-scroll">
//                 {formError && (
//                   <div className="lfc-form-error"><AlertCircle size={15} /> {formError}</div>
//                 )}

//                 <label className="lfc-label" htmlFor="lfc-label-input">Label</label>
//                 <input
//                   id="lfc-label-input"
//                   className="lfc-input"
//                   value={form.label}
//                   onChange={(e) => setForm((f) => ({ ...f, label: e.target.value }))}
//                   placeholder="e.g. Preferred move-in date"
//                   autoFocus
//                 />
//                 {panelMode === 'create' ? (
//                   <span className="lfc-key-hint">Will be saved as <code>{previewKey}</code></span>
//                 ) : (
//                   <span className="lfc-key-hint lfc-key-locked"><Lock size={11} /> Key <code>{form && editingId ? fields.find((f) => f.id === editingId)?.fieldKey : ''}</code> stays the same so past lead data isn't orphaned</span>
//                 )}

//                 <label className="lfc-label">Field type</label>
//                 <div className="lfc-type-grid">
//                   {FIELD_TYPES.map((t) => {
//                     const Icon = t.icon;
//                     const selected = form.fieldType === t.value;
//                     return (
//                       <button
//                         type="button"
//                         key={t.value}
//                         className={`lfc-type-chip ${selected ? 'is-selected' : ''}`}
//                         onClick={() => setForm((f) => ({ ...f, fieldType: t.value }))}
//                       >
//                         <Icon size={16} />
//                         <span>{t.label}</span>
//                       </button>
//                     );
//                   })}
//                 </div>

//                 {form.fieldType === 'DROPDOWN' && (
//                   <div className="lfc-options-block">
//                     <label className="lfc-label">Options</label>
//                     {form.options.map((opt, i) => (
//                       <div className="lfc-option-row" key={i}>
//                         <input
//                           className="lfc-input"
//                           value={opt}
//                           onChange={(e) => setOption(i, e.target.value)}
//                           placeholder={`Option ${i + 1}`}
//                         />
//                         {form.options.length > 1 && (
//                           <button type="button" className="lfc-icon-btn" onClick={() => removeOption(i)} aria-label="Remove option">
//                             <X size={15} />
//                           </button>
//                         )}
//                       </div>
//                     ))}
//                     <button type="button" className="lfc-add-option" onClick={addOption}>
//                       <Plus size={14} /> Add option
//                     </button>
//                   </div>
//                 )}

//                 <div className="lfc-switch-row">
//                   <div>
//                     <span className="lfc-label lfc-label-inline">Required</span>
//                     <p className="lfc-switch-hint">Your team must fill this in before saving a lead.</p>
//                   </div>
//                   <button
//                     type="button"
//                     className={`lfc-toggle ${form.required ? 'is-on' : ''}`}
//                     onClick={() => setForm((f) => ({ ...f, required: !f.required }))}
//                     aria-pressed={form.required}
//                   >
//                     <span className="lfc-toggle-thumb" />
//                   </button>
//                 </div>

//                 <label className="lfc-label">Preview on lead form</label>
//                 <FieldPreview {...form} />
//               </div>

//               <div className="lfc-drawer-foot">
//                 <button type="button" className="lfc-btn-ghost" onClick={closePanel}>Cancel</button>
//                 <button type="submit" className="lfc-btn-primary" disabled={saving}>
//                   {saving ? <Loader2 size={16} className="lfc-spin" /> : <Check size={16} />}
//                   {panelMode === 'create' ? 'Add field' : 'Save changes'}
//                 </button>
//               </div>
//             </form>
//           </aside>
//         </div>
//       )}

//       {/* ── Delete confirmation ────────────────────────────────── */}
//       {confirmDelete && (
//         <div className="lfc-overlay" onClick={() => setConfirmDelete(null)}>
//           <div className="lfc-confirm" onClick={(e) => e.stopPropagation()}>
//             <div className="lfc-empty-badge lfc-confirm-badge"><Trash2 size={20} /></div>
//             <h3>Delete "{confirmDelete.label}"?</h3>
//             <p>It disappears from new lead forms right away. Leads that already have a value saved under it keep that data.</p>
//             <div className="lfc-confirm-actions">
//               <button className="lfc-btn-ghost" onClick={() => setConfirmDelete(null)}>Cancel</button>
//               <button
//                 className="lfc-btn-danger"
//                 onClick={() => handleDelete(confirmDelete)}
//                 disabled={deletingId === confirmDelete.id}
//               >
//                 {deletingId === confirmDelete.id ? <Loader2 size={15} className="lfc-spin" /> : <Trash2 size={15} />}
//                 Delete field
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Toast ───────────────────────────────────────────────── */}
//       {toastMessage && (
//         <div className={`lfc-toast ${toastMessage.kind === 'error' ? 'is-error' : 'is-success'}`}>
//           {toastMessage.kind === 'error' ? <AlertCircle size={16} /> : <CheckCircle2 size={16} />}
//           {toastMessage.message}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ────────────────────────────────────────────────────────────────
//    Styles
//    ──────────────────────────────────────────────────────────────── */
// const CSS = `
// @import url('https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700&family=Inter:wght@400;500;600&display=swap');

// .lfc-root {
//   --bg: #FAF8FF;
//   --surface: #FFFFFF;
//   --surface-alt: #F4F0FE;
//   --purple-100: #EDE6FD;
//   --purple-200: #DCCFFB;
//   --purple-400: #A98CF5;
//   --purple-500: #8B5CF6;
//   --purple-600: #7A3FEA;
//   --purple-900: #2E1F52;
//   --ink: #362B54;
//   --muted: #8A80A6;
//   --border: #ECE4FB;
//   --danger: #E24C6D;
//   --danger-bg: #FDEDF1;
//   --success: #21A366;
//   --success-bg: #E9F9F1;
//   --radius: 14px;
//   font-family: 'Inter', -apple-system, sans-serif;
//   color: var(--ink);
//   background: var(--bg);
//   min-height: 100vh;
//   width: 100%;
// }
// .lfc-root * { box-sizing: border-box; }
// .lfc-page { max-width: 920px; margin: 0 auto; padding: 40px 24px 80px; }

// .lfc-topbar { display: flex; justify-content: space-between; align-items: flex-end; gap: 20px; margin-bottom: 28px; flex-wrap: wrap; }
// .lfc-eyebrow { font-size: 12.5px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: var(--purple-500); }
// .lfc-topbar h1 { font-family: 'Sora', sans-serif; font-size: 28px; font-weight: 700; color: var(--purple-900); margin: 4px 0 6px; }
// .lfc-sub { color: var(--muted); font-size: 14.5px; max-width: 480px; line-height: 1.5; margin: 0; }

// .lfc-btn-primary {
//   display: inline-flex; align-items: center; gap: 7px; white-space: nowrap;
//   background: var(--purple-500); color: #fff; border: none; border-radius: 10px;
//   padding: 11px 18px; font-family: 'Inter', sans-serif; font-weight: 600; font-size: 14px;
//   cursor: pointer; box-shadow: 0 8px 20px -8px rgba(139,92,246,0.55); transition: background .15s, transform .1s;
// }
// .lfc-btn-primary:hover { background: var(--purple-600); }
// .lfc-btn-primary:active { transform: translateY(1px); }
// .lfc-btn-primary:disabled { opacity: 0.65; cursor: default; }

// .lfc-btn-ghost {
//   background: transparent; border: 1px solid var(--border); color: var(--ink);
//   border-radius: 10px; padding: 10px 16px; font-weight: 600; font-size: 14px; cursor: pointer;
// }
// .lfc-btn-ghost:hover { background: var(--surface-alt); }

// .lfc-btn-danger {
//   display: inline-flex; align-items: center; gap: 7px;
//   background: var(--danger); color: #fff; border: none; border-radius: 10px;
//   padding: 10px 16px; font-weight: 600; font-size: 14px; cursor: pointer;
// }
// .lfc-btn-danger:disabled { opacity: 0.65; }

// .lfc-toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
// .lfc-search {
//   display: flex; align-items: center; gap: 8px; background: var(--surface);
//   border: 1px solid var(--border); border-radius: 10px; padding: 9px 12px; flex: 1; min-width: 200px;
//   color: var(--muted);
// }
// .lfc-search input { border: none; outline: none; font-size: 14px; flex: 1; color: var(--ink); background: transparent; }
// .lfc-segmented { display: flex; background: var(--surface-alt); border-radius: 10px; padding: 3px; }
// .lfc-segmented button {
//   border: none; background: transparent; padding: 7px 14px; border-radius: 8px; font-size: 13.5px;
//   font-weight: 600; color: var(--muted); cursor: pointer;
// }
// .lfc-segmented button.is-active { background: var(--surface); color: var(--purple-600); box-shadow: 0 1px 3px rgba(46,31,82,0.1); }
// .lfc-count { font-size: 13px; color: var(--muted); white-space: nowrap; margin-left: auto; }

// .lfc-panel-surface { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; box-shadow: 0 10px 30px -18px rgba(46,31,82,0.25); }

// .lfc-table { width: 100%; border-collapse: collapse; }
// .lfc-table thead th {
//   text-align: left; font-size: 11.5px; text-transform: uppercase; letter-spacing: 0.05em;
//   color: var(--muted); font-weight: 600; padding: 14px 20px; border-bottom: 1px solid var(--border);
// }
// .lfc-table tbody tr { border-bottom: 1px solid var(--border); transition: background .12s; }
// .lfc-table tbody tr:last-child { border-bottom: none; }
// .lfc-table tbody tr:hover { background: var(--surface-alt); }
// .lfc-table tbody tr.is-inactive { opacity: 0.55; }
// .lfc-table td { padding: 14px 20px; vertical-align: middle; font-size: 14px; }

// .lfc-field-cell { display: flex; flex-direction: column; gap: 2px; }
// .lfc-field-label { font-weight: 600; color: var(--purple-900); }
// .lfc-field-key { font-family: 'SFMono-Regular', ui-monospace, monospace; font-size: 12px; color: var(--muted); }

// .lfc-type-badge {
//   display: inline-flex; align-items: center; gap: 6px; background: var(--surface-alt);
//   color: var(--purple-600); padding: 5px 10px; border-radius: 8px; font-size: 12.5px; font-weight: 600;
// }
// .lfc-required-yes { color: var(--purple-500); display: inline-flex; }
// .lfc-required-no { color: var(--muted); }

// .lfc-status-pill {
//   display: inline-flex; align-items: center; gap: 6px; border: 1px solid transparent; border-radius: 20px;
//   padding: 5px 12px 5px 10px; font-size: 12.5px; font-weight: 600; cursor: pointer;
// }
// .lfc-status-pill.is-on { background: var(--success-bg); color: var(--success); }
// .lfc-status-pill.is-off { background: #F2EFFA; color: var(--muted); }
// .lfc-status-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }

// .lfc-row-actions { display: flex; gap: 6px; justify-content: flex-end; }
// .lfc-icon-btn {
//   width: 32px; height: 32px; display: inline-flex; align-items: center; justify-content: center;
//   border-radius: 8px; border: 1px solid var(--border); background: var(--surface); color: var(--ink); cursor: pointer;
// }
// .lfc-icon-btn:hover { background: var(--surface-alt); }
// .lfc-icon-btn-danger:hover { background: var(--danger-bg); color: var(--danger); border-color: var(--danger-bg); }

// .lfc-skeletons { padding: 8px 20px; }
// .lfc-skeleton-row { height: 52px; margin: 8px 0; border-radius: 10px; background: linear-gradient(90deg, var(--surface-alt) 25%, #fbfaff 37%, var(--surface-alt) 63%); background-size: 400% 100%; animation: lfc-shimmer 1.4s ease infinite; }
// @keyframes lfc-shimmer { 0% { background-position: 100% 0; } 100% { background-position: 0 0; } }

// .lfc-empty { text-align: center; padding: 64px 24px; }
// .lfc-empty-badge { width: 48px; height: 48px; border-radius: 12px; background: var(--surface-alt); color: var(--purple-500); display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; }
// .lfc-empty h3 { font-family: 'Sora', sans-serif; color: var(--purple-900); margin: 0 0 6px; font-size: 17px; }
// .lfc-empty p { color: var(--muted); font-size: 14px; max-width: 320px; margin: 0 auto 20px; line-height: 1.5; }

// .lfc-overlay { position: fixed; inset: 0; background: rgba(46,31,82,0.28); backdrop-filter: blur(2px); display: flex; justify-content: flex-end; z-index: 50; animation: lfc-fade .15s ease; }
// @keyframes lfc-fade { from { opacity: 0; } to { opacity: 1; } }

// .lfc-drawer { width: 420px; max-width: 100vw; height: 100vh; background: var(--surface); display: flex; flex-direction: column; box-shadow: -20px 0 40px rgba(46,31,82,0.15); animation: lfc-slide .18s ease; }
// @keyframes lfc-slide { from { transform: translateX(24px); opacity: 0.6; } to { transform: translateX(0); opacity: 1; } }

// .lfc-drawer-head { display: flex; justify-content: space-between; align-items: center; padding: 20px 22px; border-bottom: 1px solid var(--border); }
// .lfc-drawer-head h2 { font-family: 'Sora', sans-serif; font-size: 18px; color: var(--purple-900); margin: 0; }

// .lfc-form { display: flex; flex-direction: column; flex: 1; min-height: 0; }
// .lfc-form-scroll { padding: 20px 22px; overflow-y: auto; flex: 1; }
// .lfc-drawer-foot { display: flex; justify-content: flex-end; gap: 10px; padding: 16px 22px; border-top: 1px solid var(--border); }

// .lfc-form-error { display: flex; gap: 8px; align-items: flex-start; background: var(--danger-bg); color: var(--danger); padding: 10px 12px; border-radius: 10px; font-size: 13.5px; margin-bottom: 16px; }

// .lfc-label { display: block; font-size: 12.5px; font-weight: 600; color: var(--purple-900); margin: 18px 0 8px; text-transform: uppercase; letter-spacing: 0.03em; }
// .lfc-label:first-child { margin-top: 0; }
// .lfc-label-inline { margin-bottom: 2px; text-transform: none; letter-spacing: 0; font-size: 14px; }

// .lfc-input {
//   width: 100%; border: 1px solid var(--border); border-radius: 10px; padding: 10px 12px;
//   font-size: 14px; font-family: 'Inter', sans-serif; color: var(--ink); outline: none; background: var(--surface);
// }
// .lfc-input:focus { border-color: var(--purple-400); box-shadow: 0 0 0 3px var(--purple-100); }

// .lfc-key-hint { display: block; font-size: 12px; color: var(--muted); margin-top: 6px; }
// .lfc-key-hint code { background: var(--surface-alt); color: var(--purple-600); padding: 1px 6px; border-radius: 5px; font-family: ui-monospace, monospace; }
// .lfc-key-locked { display: flex; align-items: center; gap: 5px; }

// .lfc-type-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
// .lfc-type-chip {
//   display: flex; align-items: center; gap: 8px; border: 1px solid var(--border); background: var(--surface);
//   border-radius: 10px; padding: 10px 12px; font-size: 13.5px; font-weight: 600; color: var(--ink); cursor: pointer; text-align: left;
// }
// .lfc-type-chip:hover { background: var(--surface-alt); }
// .lfc-type-chip.is-selected { background: var(--purple-500); border-color: var(--purple-500); color: #fff; }

// .lfc-options-block { margin-top: 4px; }
// .lfc-option-row { display: flex; gap: 8px; margin-bottom: 8px; align-items: center; }
// .lfc-option-row .lfc-input { flex: 1; }
// .lfc-add-option { display: inline-flex; align-items: center; gap: 6px; background: none; border: none; color: var(--purple-600); font-weight: 600; font-size: 13px; cursor: pointer; padding: 4px 0; }

// .lfc-switch-row { display: flex; justify-content: space-between; align-items: center; margin-top: 20px; gap: 16px; }
// .lfc-switch-hint { font-size: 12.5px; color: var(--muted); margin: 0; max-width: 260px; }
// .lfc-toggle { width: 42px; height: 24px; border-radius: 20px; border: none; background: var(--purple-200); position: relative; cursor: pointer; flex-shrink: 0; transition: background .15s; }
// .lfc-toggle.is-on { background: var(--purple-500); }
// .lfc-toggle-thumb { position: absolute; top: 3px; left: 3px; width: 18px; height: 18px; border-radius: 50%; background: #fff; transition: transform .15s; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }
// .lfc-toggle.is-on .lfc-toggle-thumb { transform: translateX(18px); }

// .lfc-preview { background: var(--surface-alt); border: 1px dashed var(--purple-200); border-radius: 12px; padding: 16px; }
// .lfc-preview-label { display: block; font-size: 13px; font-weight: 600; color: var(--purple-900); margin-bottom: 8px; }
// .lfc-req { color: var(--danger); margin-left: 3px; }
// .lfc-preview input, .lfc-preview textarea, .lfc-preview select {
//   width: 100%; border: 1px solid var(--purple-200); border-radius: 8px; padding: 8px 10px; font-size: 13.5px;
//   background: #fff; color: var(--muted); font-family: 'Inter', sans-serif; resize: none;
// }
// .lfc-preview-switch { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--muted); }
// .lfc-switch-track { width: 34px; height: 20px; border-radius: 20px; background: var(--purple-200); position: relative; }
// .lfc-switch-thumb { width: 14px; height: 14px; border-radius: 50%; background: #fff; position: absolute; top: 3px; left: 3px; }

// .lfc-confirm { background: var(--surface); border-radius: 16px; padding: 28px; max-width: 380px; margin: auto; text-align: center; box-shadow: 0 20px 50px rgba(46,31,82,0.25); }
// .lfc-confirm-badge { background: var(--danger-bg); color: var(--danger); }
// .lfc-confirm h3 { font-family: 'Sora', sans-serif; color: var(--purple-900); font-size: 17px; margin: 0 0 8px; }
// .lfc-confirm p { color: var(--muted); font-size: 13.5px; line-height: 1.5; margin: 0 0 20px; }
// .lfc-confirm-actions { display: flex; gap: 10px; justify-content: center; }

// .lfc-toast {
//   position: fixed; bottom: 24px; right: 24px; display: flex; align-items: center; gap: 8px;
//   background: var(--purple-900); color: #fff; padding: 12px 18px; border-radius: 10px; font-size: 13.5px;
//   font-weight: 500; box-shadow: 0 10px 30px rgba(46,31,82,0.35); z-index: 60; animation: lfc-toast-in .2s ease;
// }
// .lfc-toast.is-error { background: var(--danger); }
// .lfc-toast.is-success { background: var(--purple-900); }
// @keyframes lfc-toast-in { from { transform: translateY(8px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

// .lfc-spin { animation: lfc-spin 0.8s linear infinite; }
// @keyframes lfc-spin { to { transform: rotate(360deg); } }

// @media (max-width: 720px) {
//   .lfc-table thead { display: none; }
//   .lfc-table, .lfc-table tbody, .lfc-table tr, .lfc-table td { display: block; width: 100%; }
//   .lfc-table tr { padding: 14px 16px; }
//   .lfc-table td { padding: 4px 0; border: none; }
//   .lfc-row-actions { justify-content: flex-start; margin-top: 8px; }
//   .lfc-drawer { width: 100vw; }
// }
// `;





import React, { useEffect, useMemo, useState, useCallback, useContext } from 'react';
import axios from 'axios';
import { API_URL } from '../../Constants';
import { AuthContext } from "../context/AuthContext";
import {
  Plus, X, Pencil, Trash2, Search, Check, AlertCircle,
  Type, AlignLeft, Hash, Calendar, ToggleLeft, ListChecks,
  Mail, Phone, Loader2, Lock, CheckCircle2,
} from 'lucide-react';

/* ────────────────────────────────────────────────────────────────
   Field type registry
   ──────────────────────────────────────────────────────────────── */
const FIELD_TYPES = [
  { value: 'TEXT', label: 'Text', icon: Type, hint: 'One line of text' },
  { value: 'TEXTAREA', label: 'Paragraph', icon: AlignLeft, hint: 'A few lines of text' },
  { value: 'NUMBER', label: 'Number', icon: Hash, hint: 'Digits only' },
  { value: 'DATE', label: 'Date', icon: Calendar, hint: 'A calendar date' },
  { value: 'BOOLEAN', label: 'Yes / No', icon: ToggleLeft, hint: 'A simple switch' },
  { value: 'DROPDOWN', label: 'Dropdown', icon: ListChecks, hint: 'Pick one option' },
  { value: 'EMAIL', label: 'Email', icon: Mail, hint: 'An email address' },
  { value: 'PHONE', label: 'Phone', icon: Phone, hint: 'A phone number' },
];
const TYPE_MAP = Object.fromEntries(FIELD_TYPES.map((t) => [t.value, t]));

/* ────────────────────────────────────────────────────────────────
   Live preview
   ──────────────────────────────────────────────────────────────── */
function FieldPreview({ label, fieldType, options, required }) {
  const cleanOptions = (options || []).filter((o) => o.trim());
  const displayLabel = label.trim() || 'Untitled field';

  return (
    <div className="lfc-preview">
      <label className="lfc-preview-label">
        {displayLabel}
        {required && <span className="lfc-req">*</span>}
      </label>
      {fieldType === 'TEXTAREA' && <textarea disabled rows={3} placeholder="Team types their answer here…" />}
      {fieldType === 'BOOLEAN' && (
        <div className="lfc-preview-switch">
          <div className="lfc-switch-track"><div className="lfc-switch-thumb" /></div>
          <span>No</span>
        </div>
      )}
      {fieldType === 'DROPDOWN' && (
        <select disabled>
          <option>{cleanOptions[0] || 'Choose an option…'}</option>
          {cleanOptions.slice(1).map((o, i) => <option key={i}>{o}</option>)}
        </select>
      )}
      {fieldType === 'DATE' && <input disabled type="text" placeholder="dd / mm / yyyy" />}
      {fieldType === 'NUMBER' && <input disabled type="text" placeholder="0" />}
      {fieldType === 'EMAIL' && <input disabled type="text" placeholder="name@company.com" />}
      {fieldType === 'PHONE' && <input disabled type="text" placeholder="+91 98765 43210" />}
      {fieldType === 'TEXT' && <input disabled type="text" placeholder="Team types their answer here…" />}
    </div>
  );
}

/* ────────────────────────────────────────────────────────────────
   Main page
   ──────────────────────────────────────────────────────────────── */
export default function LeadConfig() {
  const { user } = useContext(AuthContext);
  const isCompanyOwner = user?.accountType === "COMPANY";
  const companyId = isCompanyOwner ? user?.id : user?.companyId;
  const token = localStorage.getItem('token');

  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeOnly, setActiveOnly] = useState(false);
  const [query, setQuery] = useState('');

  const [panelMode, setPanelMode] = useState(null); // 'create' | 'edit' | null
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ label: '', fieldType: 'TEXT', options: [''], required: false });
  const [formError, setFormError] = useState('');
  const [saving, setSaving] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [togglingId, setTogglingId] = useState(null);
  const [toastMessage, setToastMessage] = useState(null); // Renamed to avoid react-toastify conflict naming

  // Setup Axios Instance
  const axiosInstance = useMemo(() => axios.create({
    baseURL: API_URL,
    headers: { Authorization: `Bearer ${token}` }
  }), [token]);

  const API_BASE = '/api/lead-fields';

  // Component-bound API logic
  const api = useMemo(() => ({
    list: async (activeOnly) => {
      const { data } = await axiosInstance.get(`${API_BASE}/company/${companyId}?activeOnly=${activeOnly ? 'true' : 'false'}`);
      return data;
    },
    create: async (payload) => {
      const body = {
        companyId: companyId,
        label: payload.label.trim(),
        fieldType: payload.fieldType,
        required: !!payload.required,
      };
      if (payload.fieldType === 'DROPDOWN') {
        body.options = payload.options.filter((o) => o.trim());
      }
      const { data } = await axiosInstance.post(API_BASE, body);
      return data;
    },
    update: async (id, payload) => {
      const body = {
        label: payload.label.trim(),
        fieldType: payload.fieldType,
        required: !!payload.required,
      };
      if (payload.fieldType === 'DROPDOWN') {
        body.options = payload.options.filter((o) => o.trim());
      }
      const { data } = await axiosInstance.put(`${API_BASE}/${id}?companyId=${companyId}`, body);
      return data;
    },
    setActive: async (id, active) => {
      const { data } = await axiosInstance.put(`${API_BASE}/${id}/active?companyId=${companyId}&active=${active ? 'true' : 'false'}`);
      return data;
    },
    remove: async (id) => {
      const { data } = await axiosInstance.delete(`${API_BASE}/${id}?companyId=${companyId}`);
      return data;
    }
  }), [axiosInstance, companyId]);

  const loadFields = useCallback(async () => {
    if (!companyId) return; // Prevent loading without auth context
    setLoading(true);
    try {
      const data = await api.list(activeOnly);
      setFields(data || []);
    } catch (e) {
      showToast(e.response?.data?.message || e.message || 'Could not load fields', 'error');
    } finally {
      setLoading(false);
    }
  }, [activeOnly, api, companyId]);

  useEffect(() => { loadFields(); }, [loadFields]);

  useEffect(() => {
    if (!toastMessage) return;
    const t = setTimeout(() => setToastMessage(null), 3200);
    return () => clearTimeout(t);
  }, [toastMessage]);

  function showToast(message, kind = 'success') {
    setToastMessage({ message, kind });
  }

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return fields;
    return fields.filter((f) => f.label.toLowerCase().includes(q) || f.fieldKey?.toLowerCase().includes(q));
  }, [fields, query]);

  const previewKey = useMemo(() => {
    if (panelMode === 'edit') return null;
    let base = form.label.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    return base || 'field';
  }, [form.label, panelMode]);

  function openCreate() {
    setForm({ label: '', fieldType: 'TEXT', options: [''], required: false });
    setFormError('');
    setEditingId(null);
    setPanelMode('create');
  }

  function openEdit(field) {
    setForm({
      label: field.label,
      fieldType: field.fieldType,
      options: field.options && field.options.length ? field.options : [''],
      required: field.required,
    });
    setFormError('');
    setEditingId(field.id);
    setPanelMode('edit');
  }

  function closePanel() {
    setPanelMode(null);
    setEditingId(null);
    setFormError('');
  }

  function setOption(i, value) {
    setForm((f) => ({ ...f, options: f.options.map((o, idx) => (idx === i ? value : o)) }));
  }
  function addOption() {
    setForm((f) => ({ ...f, options: [...f.options, ''] }));
  }
  function removeOption(i) {
    setForm((f) => ({ ...f, options: f.options.filter((_, idx) => idx !== i) }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setFormError('');
    if (!form.label.trim()) { setFormError('Give this field a label.'); return; }
    if (form.fieldType === 'DROPDOWN' && form.options.filter((o) => o.trim()).length === 0) {
      setFormError('Add at least one option for a dropdown field.');
      return;
    }
    setSaving(true);
    try {
      if (panelMode === 'create') {
        const created = await api.create(form);
        setFields((prev) => [...prev, created]);
        showToast(`"${created.label}" added to the lead form`);
      } else {
        const updated = await api.update(editingId, form);
        setFields((prev) => prev.map((f) => (f.id === editingId ? updated : f)));
        showToast(`"${updated.label}" updated`);
      }
      closePanel();
    } catch (err) {
      setFormError(err.response?.data?.message || err.message || 'Something went wrong. Try again.');
    } finally {
      setSaving(false);
    }
  }

  async function handleToggleActive(field) {
    setTogglingId(field.id);
    const next = !field.active;
    setFields((prev) => prev.map((f) => (f.id === field.id ? { ...f, active: next } : f)));
    try {
      await api.setActive(field.id, next);
    } catch (err) {
      setFields((prev) => prev.map((f) => (f.id === field.id ? { ...f, active: field.active } : f)));
      showToast(err.response?.data?.message || err.message || 'Could not update this field', 'error');
    } finally {
      setTogglingId(null);
    }
  }

  async function handleDelete(field) {
    setDeletingId(field.id);
    try {
      await api.remove(field.id);
      setFields((prev) => prev.filter((f) => f.id !== field.id));
      showToast(`"${field.label}" deleted`);
    } catch (err) {
      showToast(err.response?.data?.message || err.message || 'Could not delete this field', 'error');
    } finally {
      setDeletingId(null);
      setConfirmDelete(null);
    }
  }

  return (
    <div className="lfc-root">
      <style>{CSS}</style>

      <div className="lfc-page">
        <header className="lfc-topbar">
          <div>
            <span className="lfc-eyebrow">Lead configuration</span>
            <h1>Custom lead fields</h1>
            <p className="lfc-sub">Add the questions your team should answer on every lead. They appear on the lead form the moment you save them.</p>
          </div>
          <button className="lfc-btn-primary" onClick={openCreate}>
            <Plus size={17} /> Add field
          </button>
        </header>

        <div className="lfc-toolbar">
          <div className="lfc-search">
            <Search size={16} />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search fields…"
            />
          </div>
          <div className="lfc-segmented">
            <button className={!activeOnly ? 'is-active' : ''} onClick={() => setActiveOnly(false)}>All</button>
            <button className={activeOnly ? 'is-active' : ''} onClick={() => setActiveOnly(true)}>Active only</button>
          </div>
          <span className="lfc-count">{loading ? '…' : `${filtered.length} field${filtered.length === 1 ? '' : 's'}`}</span>
        </div>

        <div className="lfc-panel-surface">
          {loading ? (
            <div className="lfc-skeletons">
              {[0, 1, 2].map((i) => <div key={i} className="lfc-skeleton-row" />)}
            </div>
          ) : filtered.length === 0 ? (
            <div className="lfc-empty">
              <div className="lfc-empty-badge"><ListChecks size={22} /></div>
              <h3>{query ? 'No fields match your search' : 'No custom fields yet'}</h3>
              <p>{query ? 'Try a different name or clear the search.' : 'Create your first field so your team can capture more on every lead.'}</p>
              {!query && (
                <button className="lfc-btn-primary" onClick={openCreate}><Plus size={17} /> Add field</button>
              )}
            </div>
          ) : (
            <table className="lfc-table">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Type</th>
                  <th>Required</th>
                  <th>Status</th>
                  <th aria-hidden="true" />
                </tr>
              </thead>
              <tbody>
                {filtered.map((field) => {
                  const type = TYPE_MAP[field.fieldType] || TYPE_MAP.TEXT;
                  const Icon = type.icon;
                  return (
                    <tr key={field.id} className={!field.active ? 'is-inactive' : ''}>
                      <td>
                        <div className="lfc-field-cell">
                          <span className="lfc-field-label">{field.label}</span>
                          <span className="lfc-field-key">{field.fieldKey}</span>
                        </div>
                      </td>
                      <td>
                        <span className="lfc-type-badge">
                          <Icon size={14} /> {type.label}
                        </span>
                      </td>
                      <td>
                        {field.required ? (
                          <span className="lfc-required-yes"><Check size={15} /></span>
                        ) : (
                          <span className="lfc-required-no">—</span>
                        )}
                      </td>
                      <td>
                        <button
                          className={`lfc-status-pill ${field.active ? 'is-on' : 'is-off'}`}
                          onClick={() => handleToggleActive(field)}
                          disabled={togglingId === field.id}
                        >
                          {togglingId === field.id ? <Loader2 size={13} className="lfc-spin" /> : <span className="lfc-status-dot" />}
                          {field.active ? 'Active' : 'Inactive'}
                        </button>
                      </td>
                      <td>
                        <div className="lfc-row-actions">
                          <button className="lfc-icon-btn" onClick={() => openEdit(field)} aria-label={`Edit ${field.label}`}>
                            <Pencil size={15} />
                          </button>
                          <button className="lfc-icon-btn lfc-icon-btn-danger" onClick={() => setConfirmDelete(field)} aria-label={`Delete ${field.label}`}>
                            <Trash2 size={15} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* ── Create / edit drawer ───────────────────────────────── */}
      {panelMode && (
        <div className="lfc-overlay" onClick={closePanel}>
          <aside className="lfc-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="lfc-drawer-head">
              <h2>{panelMode === 'create' ? 'Add field' : 'Edit field'}</h2>
              <button className="lfc-icon-btn" onClick={closePanel} aria-label="Close"><X size={18} /></button>
            </div>

            <form className="lfc-form" onSubmit={handleSubmit}>
              <div className="lfc-form-scroll">
                {formError && (
                  <div className="lfc-form-error"><AlertCircle size={15} /> {formError}</div>
                )}

                <label className="lfc-label" htmlFor="lfc-label-input">Label</label>
                <input
                  id="lfc-label-input"
                  className="lfc-input"
                  value={form.label}
                  onChange={(e) => setForm((f) => ({ ...f, label: e.target.value }))}
                  placeholder="e.g. Preferred move-in date"
                  autoFocus
                />
                {panelMode === 'create' ? (
                  <span className="lfc-key-hint">Will be saved as <code>{previewKey}</code></span>
                ) : (
                  <span className="lfc-key-hint lfc-key-locked"><Lock size={11} /> Key <code>{form && editingId ? fields.find((f) => f.id === editingId)?.fieldKey : ''}</code> stays the same so past lead data isn't orphaned</span>
                )}

                <label className="lfc-label">Field type</label>
                <div className="lfc-type-grid">
                  {FIELD_TYPES.map((t) => {
                    const Icon = t.icon;
                    const selected = form.fieldType === t.value;
                    return (
                      <button
                        type="button"
                        key={t.value}
                        className={`lfc-type-chip ${selected ? 'is-selected' : ''}`}
                        onClick={() => setForm((f) => ({ ...f, fieldType: t.value }))}
                      >
                        <Icon size={16} />
                        <span>{t.label}</span>
                      </button>
                    );
                  })}
                </div>

                {form.fieldType === 'DROPDOWN' && (
                  <div className="lfc-options-block">
                    <label className="lfc-label">Options</label>
                    {form.options.map((opt, i) => (
                      <div className="lfc-option-row" key={i}>
                        <input
                          className="lfc-input"
                          value={opt}
                          onChange={(e) => setOption(i, e.target.value)}
                          placeholder={`Option ${i + 1}`}
                        />
                        {form.options.length > 1 && (
                          <button type="button" className="lfc-icon-btn" onClick={() => removeOption(i)} aria-label="Remove option">
                            <X size={15} />
                          </button>
                        )}
                      </div>
                    ))}
                    <button type="button" className="lfc-add-option" onClick={addOption}>
                      <Plus size={14} /> Add option
                    </button>
                  </div>
                )}

                <div className="lfc-switch-row">
                  <div>
                    <span className="lfc-label lfc-label-inline">Required</span>
                    <p className="lfc-switch-hint">Your team must fill this in before saving a lead.</p>
                  </div>
                  <button
                    type="button"
                    className={`lfc-toggle ${form.required ? 'is-on' : ''}`}
                    onClick={() => setForm((f) => ({ ...f, required: !f.required }))}
                    aria-pressed={form.required}
                  >
                    <span className="lfc-toggle-thumb" />
                  </button>
                </div>

                <label className="lfc-label">Preview on lead form</label>
                <FieldPreview {...form} />
              </div>

              <div className="lfc-drawer-foot">
                <button type="button" className="lfc-btn-ghost" onClick={closePanel}>Cancel</button>
                <button type="submit" className="lfc-btn-primary" disabled={saving}>
                  {saving ? <Loader2 size={16} className="lfc-spin" /> : <Check size={16} />}
                  {panelMode === 'create' ? 'Add field' : 'Save changes'}
                </button>
              </div>
            </form>
          </aside>
        </div>
      )}

      {/* ── Delete confirmation ────────────────────────────────── */}
      {confirmDelete && (
        <div className="lfc-overlay" onClick={() => setConfirmDelete(null)}>
          <div className="lfc-confirm" onClick={(e) => e.stopPropagation()}>
            <div className="lfc-empty-badge lfc-confirm-badge"><Trash2 size={20} /></div>
            <h3>Delete "{confirmDelete.label}"?</h3>
            <p>It disappears from new lead forms right away. Leads that already have a value saved under it keep that data.</p>
            <div className="lfc-confirm-actions">
              <button className="lfc-btn-ghost" onClick={() => setConfirmDelete(null)}>Cancel</button>
              <button
                className="lfc-btn-danger"
                onClick={() => handleDelete(confirmDelete)}
                disabled={deletingId === confirmDelete.id}
              >
                {deletingId === confirmDelete.id ? <Loader2 size={15} className="lfc-spin" /> : <Trash2 size={15} />}
                Delete field
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Toast ───────────────────────────────────────────────── */}
      {toastMessage && (
        <div className={`lfc-toast ${toastMessage.kind === 'error' ? 'is-error' : 'is-success'}`}>
          {toastMessage.kind === 'error' ? <AlertCircle size={16} /> : <CheckCircle2 size={16} />}
          {toastMessage.message}
        </div>
      )}
    </div>
  );
}

/* ────────────────────────────────────────────────────────────────
   Styles
   ──────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700&family=Inter:wght@400;500;600&display=swap');

.lfc-root {
  --bg: #FAF8FF;
  --surface: #FFFFFF;
  --surface-alt: #F3F4F6;
  --purple-100: #F3E8FF;
  --purple-200: #E9D5FF;
  --purple-400: #8B5CF6;
  --purple-500: #673AB7;
  --purple-600: #5E35A6;
  --purple-900: #1F2937;
  --ink: #374151;
  --muted: #6B7280;
  --border: #E5E7EB;
  --danger: #EF4444;
  --danger-bg: #FEF2F2;
  --success: #15803D;
  --success-bg: #F0FDF4;
  --radius: 14px;
  font-family: 'Inter', -apple-system, sans-serif;
  color: var(--ink);
  background: var(--bg);
  min-height: 100vh;
  width: 100%;
}
.lfc-root * { box-sizing: border-box; }
.lfc-page { max-width: 920px; margin: 0 auto; padding: 40px 24px 80px; }

.lfc-topbar { display: flex; justify-content: space-between; align-items: flex-end; gap: 20px; margin-bottom: 28px; flex-wrap: wrap; }
.lfc-eyebrow { font-size: 12.5px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: var(--purple-500); }
.lfc-topbar h1 { font-family: 'Sora', sans-serif; font-size: 28px; font-weight: 700; color: var(--purple-900); margin: 4px 0 6px; }
.lfc-sub { color: var(--muted); font-size: 14.5px; max-width: 480px; line-height: 1.5; margin: 0; }

.lfc-btn-primary {
  display: inline-flex; align-items: center; gap: 7px; white-space: nowrap;
  background: var(--purple-500); color: #fff; border: none; border-radius: 10px;
  padding: 11px 18px; font-family: 'Inter', sans-serif; font-weight: 600; font-size: 14px;
  cursor: pointer; box-shadow: 0 8px 20px -8px rgba(103,58,183,0.5); transition: background .15s, transform .1s;
}
.lfc-btn-primary:hover { background: var(--purple-600); }
.lfc-btn-primary:active { transform: translateY(1px); }
.lfc-btn-primary:disabled { opacity: 0.65; cursor: default; }

.lfc-btn-ghost {
  background: transparent; border: 1px solid var(--border); color: var(--ink);
  border-radius: 10px; padding: 10px 16px; font-weight: 600; font-size: 14px; cursor: pointer;
}
.lfc-btn-ghost:hover { background: var(--surface-alt); }

.lfc-btn-danger {
  display: inline-flex; align-items: center; gap: 7px;
  background: var(--danger); color: #fff; border: none; border-radius: 10px;
  padding: 10px 16px; font-weight: 600; font-size: 14px; cursor: pointer;
}
.lfc-btn-danger:disabled { opacity: 0.65; }

.lfc-toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.lfc-search {
  display: flex; align-items: center; gap: 8px; background: var(--surface);
  border: 1px solid var(--border); border-radius: 10px; padding: 9px 12px; flex: 1; min-width: 200px;
  color: var(--muted);
}
.lfc-search input { border: none; outline: none; font-size: 14px; flex: 1; color: var(--ink); background: transparent; }
.lfc-segmented { display: flex; background: var(--surface-alt); border-radius: 10px; padding: 3px; }
.lfc-segmented button {
  border: none; background: transparent; padding: 7px 14px; border-radius: 8px; font-size: 13.5px;
  font-weight: 600; color: var(--muted); cursor: pointer;
}
.lfc-segmented button.is-active { background: var(--surface); color: var(--purple-600); box-shadow: 0 1px 3px rgba(17,24,39,0.1); }
.lfc-count { font-size: 13px; color: var(--muted); white-space: nowrap; margin-left: auto; }

.lfc-panel-surface { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; box-shadow: 0 10px 30px -18px rgba(17,24,39,0.15); }

.lfc-table { width: 100%; border-collapse: collapse; }
.lfc-table thead th {
  text-align: left; font-size: 11.5px; text-transform: uppercase; letter-spacing: 0.05em;
  color: var(--muted); font-weight: 600; padding: 14px 20px; border-bottom: 1px solid var(--border);
}
.lfc-table tbody tr { border-bottom: 1px solid var(--border); transition: background .12s; }
.lfc-table tbody tr:last-child { border-bottom: none; }
.lfc-table tbody tr:hover { background: var(--surface-alt); }
.lfc-table tbody tr.is-inactive { opacity: 0.55; }
.lfc-table td { padding: 14px 20px; vertical-align: middle; font-size: 14px; }

.lfc-field-cell { display: flex; flex-direction: column; gap: 2px; }
.lfc-field-label { font-weight: 600; color: var(--purple-900); }
.lfc-field-key { font-family: 'SFMono-Regular', ui-monospace, monospace; font-size: 12px; color: var(--muted); }

.lfc-type-badge {
  display: inline-flex; align-items: center; gap: 6px; background: var(--surface-alt);
  color: var(--purple-600); padding: 5px 10px; border-radius: 8px; font-size: 12.5px; font-weight: 600;
}
.lfc-required-yes { color: var(--purple-500); display: inline-flex; }
.lfc-required-no { color: var(--muted); }

.lfc-status-pill {
  display: inline-flex; align-items: center; gap: 6px; border: 1px solid transparent; border-radius: 20px;
  padding: 5px 12px 5px 10px; font-size: 12.5px; font-weight: 600; cursor: pointer;
}
.lfc-status-pill.is-on { background: var(--success-bg); color: var(--success); }
.lfc-status-pill.is-off { background: #F3F4F6; color: var(--muted); }
.lfc-status-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }

.lfc-row-actions { display: flex; gap: 6px; justify-content: flex-end; }
.lfc-icon-btn {
  width: 32px; height: 32px; display: inline-flex; align-items: center; justify-content: center;
  border-radius: 8px; border: 1px solid var(--border); background: var(--surface); color: var(--ink); cursor: pointer;
}
.lfc-icon-btn:hover { background: var(--surface-alt); }
.lfc-icon-btn-danger:hover { background: var(--danger-bg); color: var(--danger); border-color: var(--danger-bg); }

.lfc-skeletons { padding: 8px 20px; }
.lfc-skeleton-row { height: 52px; margin: 8px 0; border-radius: 10px; background: linear-gradient(90deg, var(--surface-alt) 25%, #ffffff 37%, var(--surface-alt) 63%); background-size: 400% 100%; animation: lfc-shimmer 1.4s ease infinite; }
@keyframes lfc-shimmer { 0% { background-position: 100% 0; } 100% { background-position: 0 0; } }

.lfc-empty { text-align: center; padding: 64px 24px; }
.lfc-empty-badge { width: 48px; height: 48px; border-radius: 12px; background: var(--surface-alt); color: var(--purple-500); display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; }
.lfc-empty h3 { font-family: 'Sora', sans-serif; color: var(--purple-900); margin: 0 0 6px; font-size: 17px; }
.lfc-empty p { color: var(--muted); font-size: 14px; max-width: 320px; margin: 0 auto 20px; line-height: 1.5; }

.lfc-overlay { position: fixed; inset: 0; background: rgba(17,24,39,0.4); backdrop-filter: blur(2px); display: flex; justify-content: flex-end; z-index: 50; animation: lfc-fade .15s ease; }
@keyframes lfc-fade { from { opacity: 0; } to { opacity: 1; } }

.lfc-drawer { width: 420px; max-width: 100vw; height: 100vh; background: var(--surface); display: flex; flex-direction: column; box-shadow: -20px 0 40px rgba(17,24,39,0.15); animation: lfc-slide .18s ease; }
@keyframes lfc-slide { from { transform: translateX(24px); opacity: 0.6; } to { transform: translateX(0); opacity: 1; } }

.lfc-drawer-head { display: flex; justify-content: space-between; align-items: center; padding: 20px 22px; border-bottom: 1px solid var(--border); }
.lfc-drawer-head h2 { font-family: 'Sora', sans-serif; font-size: 18px; color: var(--purple-900); margin: 0; }

.lfc-form { display: flex; flex-direction: column; flex: 1; min-height: 0; }
.lfc-form-scroll { padding: 20px 22px; overflow-y: auto; flex: 1; }
.lfc-drawer-foot { display: flex; justify-content: flex-end; gap: 10px; padding: 16px 22px; border-top: 1px solid var(--border); }

.lfc-form-error { display: flex; gap: 8px; align-items: flex-start; background: var(--danger-bg); color: var(--danger); padding: 10px 12px; border-radius: 10px; font-size: 13.5px; margin-bottom: 16px; }

.lfc-label { display: block; font-size: 12.5px; font-weight: 600; color: var(--purple-900); margin: 18px 0 8px; text-transform: uppercase; letter-spacing: 0.03em; }
.lfc-label:first-child { margin-top: 0; }
.lfc-label-inline { margin-bottom: 2px; text-transform: none; letter-spacing: 0; font-size: 14px; }

.lfc-input {
  width: 100%; border: 1px solid var(--border); border-radius: 10px; padding: 10px 12px;
  font-size: 14px; font-family: 'Inter', sans-serif; color: var(--ink); outline: none; background: var(--surface);
}
.lfc-input:focus { border-color: var(--purple-400); box-shadow: 0 0 0 3px var(--purple-100); }

.lfc-key-hint { display: block; font-size: 12px; color: var(--muted); margin-top: 6px; }
.lfc-key-hint code { background: var(--surface-alt); color: var(--purple-600); padding: 1px 6px; border-radius: 5px; font-family: ui-monospace, monospace; }
.lfc-key-locked { display: flex; align-items: center; gap: 5px; }

.lfc-type-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
.lfc-type-chip {
  display: flex; align-items: center; gap: 8px; border: 1px solid var(--border); background: var(--surface);
  border-radius: 10px; padding: 10px 12px; font-size: 13.5px; font-weight: 600; color: var(--ink); cursor: pointer; text-align: left;
}
.lfc-type-chip:hover { background: var(--surface-alt); }
.lfc-type-chip.is-selected { background: var(--purple-500); border-color: var(--purple-500); color: #fff; }

.lfc-options-block { margin-top: 4px; }
.lfc-option-row { display: flex; gap: 8px; margin-bottom: 8px; align-items: center; }
.lfc-option-row .lfc-input { flex: 1; }
.lfc-add-option { display: inline-flex; align-items: center; gap: 6px; background: none; border: none; color: var(--purple-600); font-weight: 600; font-size: 13px; cursor: pointer; padding: 4px 0; }

.lfc-switch-row { display: flex; justify-content: space-between; align-items: center; margin-top: 20px; gap: 16px; }
.lfc-switch-hint { font-size: 12.5px; color: var(--muted); margin: 0; max-width: 260px; }
.lfc-toggle { width: 42px; height: 24px; border-radius: 20px; border: none; background: var(--purple-200); position: relative; cursor: pointer; flex-shrink: 0; transition: background .15s; }
.lfc-toggle.is-on { background: var(--purple-500); }
.lfc-toggle-thumb { position: absolute; top: 3px; left: 3px; width: 18px; height: 18px; border-radius: 50%; background: #fff; transition: transform .15s; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }
.lfc-toggle.is-on .lfc-toggle-thumb { transform: translateX(18px); }

.lfc-preview { background: var(--surface-alt); border: 1px dashed var(--purple-200); border-radius: 12px; padding: 16px; }
.lfc-preview-label { display: block; font-size: 13px; font-weight: 600; color: var(--purple-900); margin-bottom: 8px; }
.lfc-req { color: var(--danger); margin-left: 3px; }
.lfc-preview input, .lfc-preview textarea, .lfc-preview select {
  width: 100%; border: 1px solid var(--purple-200); border-radius: 8px; padding: 8px 10px; font-size: 13.5px;
  background: #fff; color: var(--muted); font-family: 'Inter', sans-serif; resize: none;
}
.lfc-preview-switch { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--muted); }
.lfc-switch-track { width: 34px; height: 20px; border-radius: 20px; background: var(--purple-200); position: relative; }
.lfc-switch-thumb { width: 14px; height: 14px; border-radius: 50%; background: #fff; position: absolute; top: 3px; left: 3px; }

.lfc-confirm { background: var(--surface); border-radius: 16px; padding: 28px; max-width: 380px; margin: auto; text-align: center; box-shadow: 0 20px 50px rgba(17,24,39,0.25); }
.lfc-confirm-badge { background: var(--danger-bg); color: var(--danger); }
.lfc-confirm h3 { font-family: 'Sora', sans-serif; color: var(--purple-900); font-size: 17px; margin: 0 0 8px; }
.lfc-confirm p { color: var(--muted); font-size: 13.5px; line-height: 1.5; margin: 0 0 20px; }
.lfc-confirm-actions { display: flex; gap: 10px; justify-content: center; }

.lfc-toast {
  position: fixed; bottom: 24px; right: 24px; display: flex; align-items: center; gap: 8px;
  background: var(--purple-900); color: #fff; padding: 12px 18px; border-radius: 10px; font-size: 13.5px;
  font-weight: 500; box-shadow: 0 10px 30px rgba(17,24,39,0.3); z-index: 60; animation: lfc-toast-in .2s ease;
}
.lfc-toast.is-error { background: var(--danger); }
.lfc-toast.is-success { background: var(--purple-900); }
@keyframes lfc-toast-in { from { transform: translateY(8px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

.lfc-spin { animation: lfc-spin 0.8s linear infinite; }
@keyframes lfc-spin { to { transform: rotate(360deg); } }

@media (max-width: 720px) {
  .lfc-table thead { display: none; }
  .lfc-table, .lfc-table tbody, .lfc-table tr, .lfc-table td { display: block; width: 100%; }
  .lfc-table tr { padding: 14px 16px; }
  .lfc-table td { padding: 4px 0; border: none; }
  .lfc-row-actions { justify-content: flex-start; margin-top: 8px; }
  .lfc-drawer { width: 100vw; }
}
`;